export default __webpack_public_path__ + "static/media/calgary.4eb34793.jpg";